export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Trusted Water Damage Experts in Merced
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Indoor-Restore Services is your trusted partner for emergency water damage restoration in Merced, California. With years of experience and a commitment to excellence, we provide fast, reliable, and professional restoration services to residential and commercial properties throughout the Central Valley.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our team of certified technicians uses state-of-the-art equipment and proven techniques to restore your property quickly and efficiently. We understand the stress and disruption that water damage can cause, which is why we're available 24/7 to respond to emergencies.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              From initial assessment to final restoration, we work directly with your insurance company to make the process as smooth as possible. Our goal is to return your property to its pre-damage condition while minimizing disruption to your life or business.
            </p>
            <div className="flex flex-wrap gap-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-award-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Certified Professionals</h4>
                  <p className="text-sm text-gray-600">IICRC certified technicians</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-customer-service-2-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Insurance Assistance</h4>
                  <p className="text-sm text-gray-600">We work with all major insurers</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" style={{height: '480px'}}>
              <img 
                src="https://public.readdy.ai/ai/img_res/17b344fab981fd61da663e3037f8696d.jpg" 
                alt="About Indoor-Restore Services - Water Damage Experts in Merced CA"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-8 rounded-xl shadow-xl max-w-xs">
              <div className="text-5xl font-bold mb-2">15+</div>
              <div className="text-lg">Years of Experience in Water Damage Restoration</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
